import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../styles/Navbar.css";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Function to check if link is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        <a href="/">
          <img
            src="https://makalukkaga.mpeoplesnet.com/imagesebf/mainlogo.png"
            className="logo"
            alt="Logo"
          />
        </a>
        <button className="menu-toggle" onClick={toggleMenu}>
          ☰
        </button>
        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          <li>
            <a href="/" className={isActive("/") ? "active" : ""}>
              முகப்பு
            </a>
          </li>
          <li>
            <a href="/about" className={isActive("/about") ? "active" : ""}>
              எங்களை பற்றி
            </a>
          </li>
          <li>
            <a
              href="/stalldetails"
              className={isActive("/stalldetails") ? "active" : ""}
            >
              அரங்க விவரம்
            </a>
          </li>
          <li>
            <a href="/venue" className={isActive("/venue") ? "active" : ""}>
              இடம் & நேரம்
            </a>
          </li>
          <li>
            <a
              href="/highlights"
              className={isActive("/highlights") ? "active" : ""}
            >
              சிறப்பம்சங்கள்
            </a>
          </li>
          <li>
            <a
              href="/videos"
              className={isActive("/videos") ? "active" : ""}
            >
              வீடியோக்கள்
            </a>
          </li>
          <li>
            <a href="/contact" className={isActive("/contact") ? "active" : ""}>
              தொடர்பிக்க
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
